import React from 'react';
interface ScoreBreakdownProps {
  residentScore: number;
  financialScore: number;
}
export function ScoreBreakdown({
  residentScore,
  financialScore
}: ScoreBreakdownProps) {
  return <div className="space-y-3" data-id="element-29">
      <div data-id="element-30">
        <div className="flex justify-between items-center mb-1.5" data-id="element-31">
          <span className="text-sm text-gray-600" data-id="element-32">Resident Experience</span>
          <span className="text-sm font-semibold text-gray-900" data-id="element-33">
            {residentScore}
          </span>
        </div>
        <div className="h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-34">
          <div className="h-full bg-blue-600 rounded-full transition-all duration-700 ease-out" style={{
          width: `${residentScore}%`
        }} data-id="element-35" />
        </div>
      </div>
      <div data-id="element-36">
        <div className="flex justify-between items-center mb-1.5" data-id="element-37">
          <span className="text-sm text-gray-600" data-id="element-38">Financial Performance</span>
          <span className="text-sm font-semibold text-gray-900" data-id="element-39">
            {financialScore}
          </span>
        </div>
        <div className="h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-40">
          <div className="h-full bg-blue-600 rounded-full transition-all duration-700 ease-out" style={{
          width: `${financialScore}%`
        }} data-id="element-41" />
        </div>
      </div>
    </div>;
}